type AdPauseListener = (paused: boolean) => void;

let paused = false;
const listeners = new Set<AdPauseListener>();

/**
 * Single integration point for ad-driven pause: the lifecycle layer flips this
 * on `adStarted` and back on `adFinished`/`adError`; tasks with timers can
 * subscribe instead of listening to platform ad events directly (canon 03 §8.5).
 */
export function setAdPaused(next: boolean): void {
  if (next === paused) {
    return;
  }
  paused = next;
  for (const listener of listeners) {
    listener(paused);
  }
}

export function getAdPaused(): boolean {
  return paused;
}

export function subscribeAdPause(listener: AdPauseListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
